import { FC } from 'react';

import Table from 'modules/_shared/Table';
import NotesSectionTableHeader from './NotesSectionTableHeader';
import NotesSectionTableBody from './NotesSectionTableBody';

const NotesSectionTable: FC = () => {
  const tableContent = (
    <>
      <NotesSectionTableHeader />
      <NotesSectionTableBody />
    </>
  );

  return (
    <div className="card card-bordered card-preview">
      <Table content={tableContent} />
    </div>
  );
};

export default NotesSectionTable;
